
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpinnerService } from '@app/services/common/SpinnerService';
import { finalize, Observable, Subscription } from 'rxjs';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private readonly spinnerService: SpinnerService) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.spinnerService.skipSpinnerForURL) {
      // Skip spinner for specific URLs
      const shouldSkipSpinner = req.url.includes(this.spinnerService.skipSpinnerForURL); // set the url in spinner service before calling the API which you wanna skip spin for

      if (shouldSkipSpinner) {
        return next.handle(req); // skip spinner logic
      }
    }
    
    const spinnerSubscription: Subscription = this.spinnerService.spinner$.subscribe();
    return next.handle(req).pipe(finalize(() => spinnerSubscription.unsubscribe()));
  }
}